import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import dateRange from '../../../../assets/image/date_range.svg';
import { enUS } from 'date-fns/locale';
import { getDate } from '../../../../utils/dateUtils';
import Button from '../../../../component/ui/Button';

const CustomDateRange = ({ range, setRange, handleDataByDateRange }) => {
	const [showCalendar, setShowCalendar] = useState(false);
	const [localDateRange, setLocalDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
		key: 'selection',
	});

	useEffect(() => {
		if (range.start_date || range.end_date) {
			setLocalDateRange((prev) => ({
				...prev,
				startDate: range.start_date,
				endDate: range.end_date,
			}));
		}
	}, [range.start_date, range.end_date]);

	return (
		<div style={{ position: 'relative', display: 'inline-block' }}>
			<button
				onClick={() => setShowCalendar(!showCalendar)}
				style={{
					padding: '5px 10px',
					borderRadius: '6px',
					border: '1px solid #ccc',
					backgroundColor: '#f9f9f9',
					cursor: 'pointer',
				}}
			>
				<div>
					<img
						src={dateRange}
						alt="Date"
						width={20}
						height={20}
					/>
					<span className="text-dark mx-4">
						{range.start_date !== null && range.end_date !== null
							? `${getDate(range.start_date)} - ${getDate(range.end_date)}`
							: 'Select Date Range'}
					</span>
				</div>
			</button>

			{showCalendar && (
				<div
					style={{
						position: 'absolute',
						top: '40px',
						zIndex: 100,
						boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
						borderRadius: '12px',
						overflow: 'hidden',
					}}
				>
					<DateRange
						editableDateInputs={true}
						onChange={(range) => {
							setLocalDateRange(range.selection);
						}}
						moveRangeOnFirstSelection={false}
						ranges={[localDateRange]}
						locale={enUS}
					/>
					<div className="text-center px-5 py-3 bg-white">
						<Button
							onClick={() => {
								setRange((prev) => ({
									...prev,
									start_date: localDateRange.startDate,
									end_date: localDateRange.endDate,
								}));
								setShowCalendar(false);
							}}
							type="button"
							button="Apply Now"
							className="mt-0 px-4 btn-primary relative"
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default CustomDateRange;
